import { useEffect } from 'react'
import { apiUrls } from 'consts'
import getAll from 'utils/getAll'

interface useInitProps {
  id: number
  mode?: string
  isLoaded?: Function,
  setFilters: Function
  setLoadedFilterCount: React.Dispatch<React.SetStateAction<number | null>>
}

const useInit = (props: useInitProps) => {
  useEffect(() => {

    const filtersUrl : string = (props.mode === 'page') ? (apiUrls.actionGetPageFilters + '?id=' + props.id) : (apiUrls.actionGetReportFilters + '?id=' + props.id);

    getAll(filtersUrl).then((filters) => {
      props.setFilters(filters)

      if ((filters.length < 1) && (props.isLoaded)) {
        props.setLoadedFilterCount(0)
        props.isLoaded(true)
      }
    })
  }, [])
}

export default useInit
